<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <Invira-roles-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import InviraRolesCrud from "./InviraRolesCrud";
    export default {
        name: "InviraRolesManagementPage",
        components: {InviraRolesCrud}
    }
</script>

<style scoped>

</style>

